import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

import Tooltip from "@material-ui/core/Tooltip";

const styles = {
  tooltip: {
    marginTop: "0px",
    fontSize: "1em",
    fontWeight: "400",
  },
  text: {
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};

const EllipsedTextNew = (props) => {
  const { classes, text, maxWidth, maxHeight } = props;
  const targetRef = React.useRef();
  const [textWidth, setTextWidth] = React.useState();
  const [textHeight, setTextHeight] = React.useState();

  React.useEffect(() => {
    if (targetRef.current) {
      setTextWidth(targetRef.current.offsetWidth);
      setTextHeight(targetRef.current.offsetHeight);
    }
  }, [text]);

  let enableTooltip =
    isNaN(maxWidth) ||
    (textWidth && textWidth >= maxWidth) ||
    (textHeight && maxHeight && textHeight >= maxHeight);

  return (
    <Tooltip
      title={props.title || text}
      placement="bottom"
      classes={{ tooltip: classes.tooltip }}
      disableFocusListener={!enableTooltip}
      disableHoverListener={!enableTooltip}
      disableTouchListener={!enableTooltip}
    >
      <span
        ref={targetRef}
        className={classes.text}
        style={{
          maxWidth: isNaN(maxWidth) ? maxWidth : `${maxWidth}px`,
          maxHeight: maxHeight ? `${maxHeight}px` : "",
          whiteSpace: maxHeight ? "break-spaces" : "nowrap",
          color: props.color,
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
};

EllipsedTextNew.propTypes = {
  text: PropTypes.any,
  maxWidth: PropTypes.any.isRequired,
  maxHeight: PropTypes.number,
};

export default withStyles(styles)(EllipsedTextNew);
